module.exports = "/_next/static/resources/photo-2-a2661b4b04e10eb8b800dca5b0468706.jpg";